import React, { createContext, useCallback, useContext, useState } from 'react';
import { RectReadOnly } from 'react-use-measure';

interface DynamicPipelineContext {
  demographicMeasurements: {
    [key: string]: RectReadOnly;
  };
  setDemographicMeasurement: (key: string, measurements: RectReadOnly) => void;
  getDemographicMeasurement: (key: string) => RectReadOnly | undefined;
}

const DynamicPipelineContext = createContext<DynamicPipelineContext>({
  demographicMeasurements: {},
  setDemographicMeasurement: () => {},
  getDemographicMeasurement: () => undefined,
});

export const DynamicPipelineRenderer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [demographicMeasurements, setDemographicMeasurements] = useState<{
    [key: string]: RectReadOnly;
  }>({});

  const setDemographicMeasurement = useCallback(
    (key: string, measurements: RectReadOnly) => {
      setDemographicMeasurements((prev) => ({
        ...prev,
        [key]: measurements,
      }));
    },
    [],
  );

  const getDemographicMeasurement = useCallback(
    (key: string) => {
      return demographicMeasurements[key];
    },
    [demographicMeasurements],
  );

  return (
    <DynamicPipelineContext.Provider
      value={{
        demographicMeasurements,
        setDemographicMeasurement,
        getDemographicMeasurement,
      }}
    >
      {children}
    </DynamicPipelineContext.Provider>
  );
};

export const useDynamicPipeline = () => {
  return useContext(DynamicPipelineContext);
};
